import { IconButtonProps as ChakraIconButtonProps, IconButton as ChakraIconButton } from '@chakra-ui/react/button'
import { forwardRef, Ref } from 'react'
import { ButtonTheme } from './styles'
import { ButtonAppearance } from './types'
import { Spinner } from '@chakra-ui/react/spinner'

type IconButtonProps = ChakraIconButtonProps & {
  buttonAppearance: ButtonAppearance
  loading?: boolean
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ loading, buttonAppearance, ...props }: IconButtonProps, ref: Ref<HTMLButtonElement>) => {
    const styles = ButtonTheme.variants[buttonAppearance]
    return (
      <ChakraIconButton ref={ref} variant={styles?.variant} css={styles} {...props}>
        {loading ? <Spinner size="sm" /> : props.children}
      </ChakraIconButton>
    )
  },
)

export default IconButton
